import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Util
import { prop } from '../../../../common/utils/immutableHelper';
import fileSupportsModalView from '../utils/fileSupportsModalView';
import { getFileSizeForDisplay } from '../../../../common/files/fileSizeUtils';
import { registerDownloadSource } from '../../../utils/fileDownloader/javascriptToSwiftFileDownloads';
import { getElementId } from '../../../../common/elements/utils/elementPropertyUtils';

// Hooks
import useStableUniqueIdRef from '../../../utils/react/useStableUniqueIdRef';

// Components
import DownloadButton from '../../../components/buttons/DownloadButton';
import OpenLinkInElementModalButton from '../../../components/buttons/OpenLinkInElementModalButton';

import { useTranslator } from '../../../components/i18n/useTranslator';

const FileSecondaryDetails = ({ element, fileData, showDownloadOption, showOpenOption = true }) => {
    const [isDownloading, setIsDownloading] = useState(false);
    const uniqueId = useStableUniqueIdRef();
    const translate = useTranslator('elements', 'elementTypes.file');

    const supportsModalView = fileSupportsModalView(element);
    const elementId = getElementId(element);

    return (
        <div className="FileSecondaryDetails" id={uniqueId}>
            {fileData && showDownloadOption && (
                <DownloadButton
                    url={prop('url', fileData)}
                    filename={prop('filename', fileData)}
                    onDownloadStart={() => {
                        setIsDownloading(true);
                        registerDownloadSource(`#${uniqueId}`);
                    }}
                    onDownloadEnd={() => setIsDownloading(false)}
                    elementId={elementId}
                >
                    {translate('download')}
                </DownloadButton>
            )}
            {supportsModalView && !isDownloading && showOpenOption && (
                <>
                    <OpenLinkInElementModalButton
                        element={element}
                        divider={showDownloadOption && ' - '}
                        className="open-link"
                    >
                        {translate('open')}
                    </OpenLinkInElementModalButton>
                    {!showDownloadOption && <span>{' - '}</span>}
                </>
            )}
            {!isDownloading && (
                <>
                    <span className="file-size">
                        {showDownloadOption && <span>{' - '}</span>}
                        {getFileSizeForDisplay(prop('size', fileData))}
                    </span>
                </>
            )}
        </div>
    );
};

FileSecondaryDetails.propTypes = {
    element: PropTypes.object,
    fileData: PropTypes.object,
    showDownloadOption: PropTypes.bool,
    showOpenOption: PropTypes.bool,
};

export default FileSecondaryDetails;
